(function(){

  // TODO Detect handoff

  class UnifiedLoginElement extends HTMLElement {

    connectedCallback() {
      this.addEventListener('submit', this.submit.bind(this));     
      this._initialiseRecharge();

      const currentUrl = new URL(window.location.toString());
      if (currentUrl.searchParams.has('handoff')) {
        this._setMode('handoff');
        this._submitHandoffForm();
      } else {
        this._prefillEmailFromHash();
        this._setMode('email');
      }
    }

    // AgeMate: older emails link to /pages/subscriber-login#email=<address>. Browsers never send the
    // #fragment to servers, but page scripts can read it: the audit (23 Oct 2026) found tracking
    // pixels receiving the full URL. So layout/theme.liquid strips the hash before anything else
    // runs and keeps a copy in window.__amPrefillEmail, which is read here. [^&?] stops at a UTM
    // query a mail tool may append after the #. Prefill only: the customer checks it and taps
    // Send Login Code, so link scanners can't trigger code emails and a wrong address can be fixed.
    _prefillEmailFromHash() {
      try {
        const match = (window.__amPrefillEmail || window.location.hash).match(/(?:^#|&)email=([^&?]*)/);
        if (!match) return;
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
        const emailAddress = decodeURIComponent(match[1]).trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) return;
        const input = this.emailFormTarget.querySelector('input[name="email_address"]');
        if (input) input.value = emailAddress;
      } catch (error) {
        console.dir(['unified-login#_prefillEmailFromHash error:', error]);
      }
    }
    
    /**
     * @type {Promise<object>}
     */
    _recharge

    _initialiseRecharge() {

      this._recharge = new Promise((resolve, reject) => {
        let interval;
        interval = setInterval(() => {
          if ('recharge' in window) {
            clearInterval(interval);
            const { recharge } = window
            recharge.init({ storeIdentifier: this._storeIdentifier, storefrontAccessToken: this._storefrontToken });
            resolve(recharge);
          }
        }, 200);

        const timeout = AbortSignal.timeout(2000)
        timeout.addEventListener('abort', () => {
          clearInterval(interval);
          reject('recharge failed to load');
        });
      });
    }

    /**
     * 
     * @param {SubmitEvent} event 
     */
    async submit(event) {
      event.preventDefault();
      event.stopPropagation();

      const form = event.target;

      this._setDisabledState(form, true);

      if (form == this.emailFormTarget || form == this.handoffFormTarget) {
        await this._submitEmailForm(form);
      } else if (form == this.verifyFormTarget) {
        await this._submitVerifyForm();
      }

      this._setDisabledState(form, false);
    }

    _session
    _emailAddress

    async _submitEmailForm(form) {
      const formData = new FormData(form);
      const emailAddress = formData.get('email_address');

      this._setInvalidState(form, false);
      
      let session;
      
      const recharge = await this._recharge;
      
      try {
        session = await recharge.auth.sendPasswordlessCodeAppProxy(emailAddress);
      } catch (error) {
        
        if (form == this.emailFormTarget && error.message == 'Email Not Valid' && this._hasLookupUrl) {
          this._lookupStoreForCustomer(emailAddress);
          return;
        }
        
        this._resetForm(form);
        this._setMode('email');

        this._setInvalidState(this.emailFormTarget, true);

        return;
      }

      this._setMode('verify');

      this._emailAddress = emailAddress;
      this._session = session;
    }

    async _lookupStoreForCustomer(emailAddress) {
      try {
        const data = { email_address: emailAddress };
        
        const response = await fetch(this._lookupUrl, {
          method: 'post', mode: 'cors',
          cache: 'no-cache', credentials: 'omit',
          body: JSON.stringify(data),
          signal: AbortSignal.timeout(5000),
          headers: {
            'content-type': 'application/json',
            'x-csrf-token': this._csrfToken
          }
        });

        switch (response.status) {
          case 200: {
            const data = await response.json();
            const { host, token } = data.customer.store;
            this._redirectToStoreIfNeeded(host, token);
            return;
          }
          case 204:
          case 422: {
            this._setInvalidState(this.emailFormTarget, true);
            break;
          }
          default: {
            this._setInvalidState(this.emailFormTarget, true);
          }
        }
      } catch (error) {
        console.dir(['unified-login#_lookupStoreForCustomer error:', error]);

        switch(error.name) {
          case 'TimeoutError': {
            // TODO Retry?
            break;
          }
          default: {
            // TODO Service error
          }
        }

        this._setInvalidState(this.emailFormTarget, true);
      }

      this._setMode('email');

    }

    async _submitHandoffForm() {
      // TODO First: Base64 decode token for email (no security)
      try {
        const url = new URL(window.location.toString());

        const token = url.searchParams.get('handoff');
        const emailAddress = window.atob(token);

        const input = this.handoffFormTarget.querySelector('input[name="email_address"]')
        input.value = emailAddress;

        this.handoffFormTarget.requestSubmit();
      } catch (error) {
        console.dir(['unified-login#_submitHandoffForm error:', error]);
      }
    }

    _redirectToStoreIfNeeded(host, token) {
      const newUrl = new URL(window.location.toString());
      newUrl.host = host;
      newUrl.searchParams.append('handoff', token);
      
      window.location.assign(newUrl.toString());
    }
    
    async _submitVerifyForm() {
      const formData = new FormData(this.verifyFormTarget);
      const verificationCode = formData.get('verification_code');

      const recharge = await this._recharge;

      let portalAccess;

      try {
        const token = await recharge.auth.validatePasswordlessCodeAppProxy(this._emailAddress, this._session, verificationCode);
        portalAccess = await recharge.customer.getCustomerPortalAccess(token);
      } catch (error) {
        this._resetForm(this._submitVerifyForm);
        this._setInvalidState(this.verifyFormTarget, true);
        return;
      }

      if(!portalAccess) {
        // TODO
        return;
      }

      let { portal_url: portalUrl } = portalAccess;

      portalUrl = portalUrl.replace('/schedule', '/overview');

      window.location.assign(portalUrl);
    }

    /**
     * 
     * @param {string} mode 
     */
    _setMode(mode) {
      window.requestAnimationFrame(() => {
        switch(mode) {
          case 'verify': {
            this.emailFormTarget.style.display = 'none';
            this.handoffFormTarget.style.display = 'none';
            this.verifyFormTarget.style.display = 'block';
            break;
          }
          case 'handoff': {
            this.emailFormTarget.style.display = 'none';
            this.handoffFormTarget.style.display = 'block';
            this.verifyFormTarget.style.display = 'none';
            break;
          }
          case 'initial':
          case 'email':
          default: {
            this.emailFormTarget.style.display = 'block';
            this.handoffFormTarget.style.display = 'none';
            this.verifyFormTarget.style.display = 'none';
          }
        }
      });
    }

    /**
     * 
     * @param {HTMLFormElement} form 
     * @param {boolean} state 
     */
    _setInvalidState(form, state) {
      window.requestAnimationFrame(() => {
        form.classList.toggle('is-invalid', state);
      });
    }

    /**
     * 
     * @param {HTMLFormElement} form 
     * @param {boolean} state 
     */
    _setDisabledState(form, state) {
      window.requestAnimationFrame(() => {
        const targets = form.querySelectorAll('input:not([type="hidden"]), button');
        targets.forEach(el => state ? el.setAttribute('disabled', '') : el.removeAttribute('disabled'));
      });
    }

    /**
     * 
     * @param {HTMLFormElement} form 
     */
    _resetForm(form) {
      form.reset();
      this._setInvalidState(form, false);
    }

    /**
     * @type {string}
     */
    get _storefrontToken() {
      return this.getAttribute('data-storefront-token');
    }
    
    /**
     * @type {string}
     */
    get _storeIdentifier() {
      return this.getAttribute('data-store-identifier');
    }
    
    /**
     * @type {string}
     */
    get _lookupUrl() {
      return this.getAttribute('data-lookup-url');
    }
    
    /**
     * @type {string}
     */
    get _csrfToken() {
      return this.getAttribute('data-csrf-token');
    }
    
    /**
     * @type {boolean}
     */
    get _hasLookupUrl() {
      return typeof this._lookupUrl == 'string' && this._lookupUrl.length > 0;
    }

    /**
     * @type {HTMLFormElement}
     */
    get emailFormTarget() {
      return this.querySelector('form[name="unified_login__email"]');
    }

    /**
     * @type {HTMLInputElement}
     */
    get verifyFormTarget() {
      return this.querySelector('form[name="unified_login__verify"]');
    }

    /**
     * @type {HTMLInputElement}
     */
    get handoffFormTarget() {
      return this.querySelector('form[name="unified_login__handoff"]');
    }

  }

  window.customElements.define('unified-login', UnifiedLoginElement)

})();